import {
    ADD_DETAIL,
    EDIT_DETAIL,
    GET_DETAILS,
    REMOVE_DETAIL,
    GET_DETAIL_BY_ID,
} from "../actions/detail-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const detailReducer = (state = initialState, action: any): ApiRequestState => {
    switch (action.type) {
        case (ADD_DETAIL.REQUEST,
        GET_DETAILS.REQUEST,
        GET_DETAIL_BY_ID.REQUEST,
        EDIT_DETAIL.REQUEST,
        REMOVE_DETAIL.REQUEST):
            return {
                ...state,
                loading: true,
                error: null,
            };
        case (ADD_DETAIL.SUCCESS,
        GET_DETAILS.SUCCESS,
        GET_DETAIL_BY_ID.SUCCESS,
        EDIT_DETAIL.SUCCESS,
        REMOVE_DETAIL.SUCCESS):
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case (ADD_DETAIL.FAILURE,
        GET_DETAILS.FAILURE,
        GET_DETAIL_BY_ID.FAILURE,
        EDIT_DETAIL.FAILURE,
        REMOVE_DETAIL.FAILURE):
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export { detailReducer };
